module.exports = __webpack_public_path__ + "static/logo-ecb8222b9065a267aa2866761f4cd8e6.png";